import React, { useEffect, useState } from 'react';
import Board from 'react-trello';
import { Image, Row, Col, Container, Table } from 'react-bootstrap';
import _ from 'lodash';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import UserHistory from './UserHistory';
import usersDataMocked from './usersDataMocked.json';
import FiterAPI from '../fiterAPI';

const DEFAULT_AVATAR =
  'data:image/png;base64,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';

const response = usersDataMocked;

const MONTHS_LIST = [
  { label: 'Jan', value: '1' },
  { label: 'Fev', value: '2' },
  { label: 'Mar', value: '3' },
  { label: 'Abr', value: '4' },
  { label: 'Mai', value: '5' },
  { label: 'Jun', value: '6' },
  { label: 'Jul', value: '7' },
  { label: 'Ago', value: '8' },
  { label: 'Set', value: '9' },
  { label: 'Out', value: '10' },
  { label: 'Nov', value: '11' },
  { label: 'Dez', value: '12' }
];

const YEARS_LIST = [
  { label: '2020', value: '2020' },
  { label: '2021', value: '2021' },
  { label: '2022', value: '2022' }
];

const TURNOVER_TITLES = [
  'Prediçao Turnover Muito Baixo',
  'Prediçao Turnover Baixo',
  'Prediçao Turnover Médio Alto'
];

const cardTitle = ({ name, selfie = DEFAULT_AVATAR }) => (
  <span>
    <Image
      className="user-selfie"
      src={selfie._url || DEFAULT_AVATAR}
      alt="Selfie"
      roundedCircle
    />
    {name}
  </span>
);

const getTags = ({ evadido, riscoEvasao }) => {
  if (evadido)
    return [
      {
        title: 'Aluno evadido',
        color: 'white',
        bgcolor: '#000000'
      }
    ];
  if (riscoEvasao)
    return [
      {
        title: 'Taxa de Evasão Médio Alto',
        color: 'white',
        bgcolor: '#EB5A46'
      }
    ];
  return [];
};

const getStyle = ({ evadido }) => {
  if (evadido) return { opacity: '0.5' };
  return {};
};

const sortLane = (card1, card2) => {
  return card2.label.localeCompare(card1.label);
};

function getMonthSelection(month) {
  return MONTHS_LIST.find(mo => mo.value == month);
}

function getYearSelection(year) {
  return YEARS_LIST.find(y => y.value == year);
}

const FiterKanban = props => {
  const history = useHistory();
  const { currentInstitution, currentUser, courses } = props;
  const currentAvatar = currentInstitution.avatar[currentUser.roleName];
  const { areaId, monthFilter } = useParams();
  const [areaData, setAreaData] = useState(0);
  const [monthPassed, yearPassed] = monthFilter.split('-');
  const [month, setMonth] = useState(monthPassed);
  const [year, setYear] = useState(yearPassed);

  useEffect(() => {
    async function fetchData() {
      const _areaData = await FiterAPI.getUsersByArea(areaId, monthFilter);

      setAreaData(_areaData);
    }
    fetchData();
  }, [areaId, monthFilter]);
  // const [areaData] = _.filter(areasData, {id: areaId})
  const highTurnoverUsersCount = areaData
    ? _.filter(areaData.users, { turnover: 3, area: areaId }).length
    : [];
  const totalUsersCount = areaData ? areaData.users.length : 0;

  const cards = TURNOVER_TITLES.map(title => {
    return areaData && areaData.users.map(user => user);
  });

  const data = {
    lanes: _.map(TURNOVER_TITLES, (title, turnoverIndex) => ({
      id: turnoverIndex,
      title,
      onCardClick: (cardId, metadata, laneId) =>
        console.log(cards[laneId][cardId]),
      cards: areaData
        ? _.map(
            _.filter(
              areaData.users,
              user => user.turnover === turnoverIndex + 1
            ),
            (user, userIndex) => {
              return {
                id: userIndex,
                title: '',
                description: (
                  <UserHistory
                    currentAvatar={currentAvatar}
                    userData={user}
                    courses={courses}
                    adherence={user.adherence}
                    happiness={user.happiness}
                  />
                )
              };
            }
          )
        : []
    }))
  };

  const percentageTurnoverLimit = areaData ? areaData.turnoverLimit : 0;
  const currentTurnoverPercentage = totalUsersCount
    ? highTurnoverUsersCount / totalUsersCount
    : 0;

  const [isEditing, setIsEditing] = useState(false);
  const [monthlyValue, setMonthlyValue] = useState(
    areaData ? areaData.averageWage : 0
  );
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const [currentTurnoverValue, setCurrentTurnoverValue] = useState(
    (currentTurnoverPercentage * monthlyValue * 2.5 * totalUsersCount).toFixed(
      0
    )
  );
  const [limitTurnoverValue, setLimitTurnoverValue] = useState(
    (percentageTurnoverLimit * monthlyValue * 2.5 * totalUsersCount).toFixed(0)
  );
  const [colorStyle, setColorStyle] = useState(
    currentTurnoverPercentage > percentageTurnoverLimit
      ? 'red'
      : (currentTurnoverPercentage > percentageTurnoverLimit) - 0.01
      ? 'orange'
      : ''
  );

  const handleClickEdit = async event => {
    setIsEditing(true);
    event.target.focus();
  };

  const handleSave = async event => {
    setIsEditing(false);
    if (areaData) {
      FiterAPI.updateMontlyWage(areaData.id, monthlyValue);
      areaData.averageWage = monthlyValue;
    }
  };

  const handleTextChange = event => {
    const { value } = event.target;
    setMonthlyValue(value.replace(',', '.'));
    setCurrentTurnoverValue(
      (value * currentTurnoverPercentage * 2.5 * totalUsersCount).toFixed(0)
    );
    setLimitTurnoverValue(
      (value * percentageTurnoverLimit * 2.5 * totalUsersCount).toFixed(0)
    );
  };

  function changeDate(monthValue, yearValue) {
    setMonth(monthValue);
    setYear(yearValue);
    if (monthValue && yearValue) {
      history.push(`./${monthValue}-${yearValue}`);
    }
  }
  const showUserHistory = (history = [], radarData = []) => {
    return (
      <UserHistory
        userData="usersDataMocked"
        show={showHistoryModal}
        history={history}
        radarData={radarData}
      />
    );
  };

  return (
    <>
      <Container>
        <Row>
          <Col md={9}>
            <Board
              style={{ backgroundColor: 'white' }}
              data={data}
              // laneSortFunction={sortLane}
              laneDraggable={false}
              cardDraggable={false}
              hideCardDeleteIcon
            />
          </Col>
          <Col
            md={3}
            className="mt-2 mb-2"
            style={{
              backgroundColor: '#e3e3e357',
              borderRadius: '5px',
              fontSize: '15px'
            }}
          >
            <Row className="p-3 d-block">
              <h3>{areaData ? areaData.label : ''}</h3>
            </Row>
            <Row className="col-md-12">
              <Col md={6}>
                <Select
                  defaultValue={getMonthSelection(month)}
                  options={MONTHS_LIST}
                  placeholder="Mês"
                  onChange={e => changeDate(e.value, year)}
                />
              </Col>
              <Col md={6}>
                <Select
                  defaultValue={getYearSelection(yearPassed)}
                  options={YEARS_LIST}
                  placeholder="Ano"
                  onChange={e => changeDate(month, e.value)}
                />
              </Col>
            </Row>
            <Row className="p-3 d-block">
              <b>Salário Médio:</b>
              <br />
              <span className="ml-2" onClick={handleClickEdit}>
                {isEditing ? (
                  <input
                    style={{ width: `${100}px` }}
                    type="number"
                    value={monthlyValue}
                    onKeyPress={event => {
                      if (event.key == 'Enter') handleSave();
                    }}
                    onChange={handleTextChange}
                    onBlur={handleSave}
                  />
                ) : (
                  `R$${Number(monthlyValue)
                    .toFixed(2)
                    .replace('.', ',')}`
                )}
              </span>
            </Row>

            <Row className="p-3 d-block">
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <td colSpan={2}>Limite de turnover</td>
                  </tr>
                  <td>%</td>
                  <td>$</td>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {percentageTurnoverLimit
                        ? percentageTurnoverLimit * 100
                        : 0}
                      %
                    </td>
                    <td>R${limitTurnoverValue}</td>
                  </tr>
                </tbody>
              </Table>
            </Row>

            <Row className="p-3 d-block">
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <td colSpan={2}>Predição atual de turnover</td>
                  </tr>
                  <td>%</td>
                  <td>$</td>
                </thead>
                <tbody>
                  <tr style={{ color: colorStyle }}>
                    <td>
                      {Number(currentTurnoverPercentage * 100).toFixed(1)}%
                    </td>
                    <td>R${currentTurnoverValue}</td>
                  </tr>
                </tbody>
              </Table>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FiterKanban;
